import { useContext } from 'react';
// react bootstrap
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
// validators
import { yupResolver } from '@hookform/resolvers/yup';
import { loginSchema } from '../Form/formSchema';
// hooks
import { useForm } from 'react-hook-form';
import { useDeleteAccountLogin } from '../Hooks/useDeleteAccountLogin';
// user context
import { UserContext } from '../../userContext';

const DeleteAccountForm = ({ callback }) => {
  const [user, _setUser] = useContext(UserContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const { loading, responseError, login } = useDeleteAccountLogin();

  const handleLogin = async (data) => {
    const error = await login(data.email, data.password, user.email);

    if (error) {
      return;
    }

    //delete account
    callback();
  };

  return (
    <div>
      {responseError && <Alert variant={'danger'}>{responseError}</Alert>}
      {loading && (
        <div className={'my-3 text-center'}>
          <Spinner
            animation='border'
            variant='primary'
            className={'text-center'}
          />
        </div>
      )}
      <h1 className={'form-title'}>Enter Account Credentials</h1>
      <Form id='delete-form' onSubmit={handleSubmit(handleLogin)}>
        <Form.Group className='mb-3' controlId='formGroupEmail'>
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type='email'
            placeholder='Enter email'
            name='email'
            {...register('email', { required: true })}
            isInvalid={errors.email}
          />
          {
            <Form.Control.Feedback type='invalid'>
              {errors.email?.message}
            </Form.Control.Feedback>
          }
        </Form.Group>
        <Form.Group className='mb-3' controlId='formGroupPassword'>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type='password'
            placeholder='Password'
            name='password'
            {...register('password', { required: true })}
            isInvalid={errors.password}
          />
          {
            <Form.Control.Feedback type='invalid'>
              {errors.password?.message}
            </Form.Control.Feedback>
          }
        </Form.Group>
      </Form>
    </div>
  );
};

const DeleteAccountModal = (props) => {
  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Delete Account
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DeleteAccountForm callback={props.deleteAccount} />
      </Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={props.onHide}>
          Cancel
        </Button>
        <Button form='delete-form' variant='danger' type='submit'>
          Delete Account
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteAccountModal;
